import axios from 'axios';
import { API } from '../../constants/constants';
import Track from '../track';

export default {
    findByUUId(uuid) {
        return axios.get(API.TRACK.replace('[id]', uuid)).then(response => new Track(response.data));
    }
};
